<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-booklet-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Fiches techniques par article</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input" placeholder="Rechercher un article...">
                                <button v-if="searchword" @click="searchword = ''" class="search-clear" aria-label="Effacer"><i class="ri-close-line"></i></button>
                            </div>
                            <div class="cf-select-wrap cf-mag-select">
                                <select v-model="selectedmagasin" @change="load" class="cf-inp cf-select">
                                    <option :value="null">Sélectionner un entrepôt</option>
                                    <option v-for="(magasin,index) of listeotherdatacentredeconsommation_paramcom_magasin.magasin" :key="index" :value="magasin">{{ magasin.name }}</option>
                                </select>
                                <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                            </div>
                            <button @click="loadtrt" class="ti-btn ti-btn-light" title="Réinitialiser le contenu de la table">
                                <i class="ri-refresh-line align-middle"></i><span class="hidden sm:inline">&nbsp;Réinitialiser</span>
                            </button>
                        </div>
                        <div class="cf-toolbar-meta">
                            <label class="cf-check">
                                <input type="checkbox" v-model="activecolums1"> <span>Colonne Unité</span>
                            </label>
                            <div class="cf-perpage">
                                <label>Afficher</label>
                                <div class="cf-select-wrap">
                                    <select v-model="DefaultperPage" class="cf-select--sm">
                                        <option value="10">10</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="300">300</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                                <span class="cf-count" v-if="allItems>0"><b>{{ allItems }}</b> élément{{ allItems > 1 ? 's' : '' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body cf-dialog-body--flush">
                        <div class="table-scroll-wrap doc-scroll">
                            <table class="doc-table">
                                <thead>
                                    <tr>
                                        <th class="th">Article</th>
                                        <th class="th" v-if="activecolums1">Unité</th>
                                        <th class="th">Créé le</th>
                                        <th class="th th--center" style="width:8rem">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="loadingtable">
                                        <template v-if="filterdatatable.length">
                                            <tr class="table-row" v-for="(datavalue,index) in filterdatatable" :key="index">
                                                <td class="td cf-strong">{{ datavalue.libelle }}</td>
                                                <td class="td" v-if="activecolums1">{{ datavalue.unite }}</td>
                                                <td class="td">{{ datavalue.creerler }}</td>
                                                <td class="td td--center">
                                                    
                                                    <button @click="btnsaisiev2(datavalue)" class="ti-btn ti-btn-primary-full ti-btn-sm"><i class="ri-pen-nib-line align-middle"></i> Modifier</button>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td :colspan="activecolums1 ? 4 : 3" class="td">
                                                    <div class="empty-state">
                                                        <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                        <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                        <p class="empty-state__sub" v-if="selectedmagasin===null">Sélectionnez d'abord un entrepôt.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td :colspan="activecolums1 ? 4 : 3" class="td">
                                                <div class="animate-pulse cf-skeleton">
                                                    <div class="cf-skeleton-bar"></div>
                                                    <div class="cf-skeleton-bar"></div>
                                                    <div class="cf-skeleton-bar"></div>
                                                    <div class="cf-skeleton-bar"></div>
                                                    <div class="cf-skeleton-bar"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <p class="cf-foot-info" v-if="allItems>0">Page <b>{{ page }}</b> / <b>{{ pages.length }}</b> , <b>{{ allItems }}</b> éléments</p>
                        <span v-else></span>
                        <div class="cf-foot-actions">
                            <div class="pagination" v-if="pages.length > 1">
                                <button class="page-btn page-btn--nav" @click="page--" :disabled="page <= 1"><i class="ri-arrow-left-s-line"></i></button>
                                <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                    <span v-if="pageNumber === '...'" class="cf-ellipsis">…</span>
                                    <button v-else class="page-btn" :class="{ 'page-btn--active': pageNumber === page }" @click="page = pageNumber">{{ pageNumber }}</button>
                                </template>
                                <button class="page-btn page-btn--nav" @click="page++" :disabled="page >= pages.length"><i class="ri-arrow-right-s-line"></i></button>
                            </div>
                            <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        </div>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <modalform ref="modalform" @closed="loadtrt"></modalform>
    <modalformv2 ref="modalformv2" @closed="load"></modalformv2>
    <modalformsuppression @closed="loadtrt" ref="modalformsuppression"></modalformsuppression>

</template>

<script>
    /* import templatesite from "@/components/template/apptemplate";
     import appheader from "@/components/template/appheader";
     import appsidebar from "@/components/template/appsidebar";*/


    import {mapGetters} from "vuex";

    const axios =require('axios');

    import modalform from "@/components/views/pages/stock/fichetechnique/form";
    import modalformv2 from "@/components/views/pages/stock/fichetechnique/form_v2";
    import modalformsuppression from "@/components/views/pages/stock/fichetechnique/formsuppression";

    import {cloneobjet, currencyFormatDE, isset, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";


    /*  const isset = (accessor) => {
              try {
                  // Note we're seeing if the returned value of our function is not
                  // undefined or null
                  return accessor !== undefined && accessor !== null
              } catch (e) {
                  // And we're able to catch the Error it would normally throw for
                  // referencing a property of undefined
                  return false
              }


          }*/

    export default {
        /* eslint-disable */
        name: "fichetechnique",

        watch: {

            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            DefaultperPage: function(newvalue,oldvalue){

                this.page=1

            },



            /*  searchtrierletableau: function(newvalue,oldvalue){

                  this.page=1

                  // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
                  // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

              }*/

        },
        computed:{
            ...mapGetters(['listedesarticles','listeotherdatacentredeconsommation_paramcom_magasin']),

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                // let mvalue=this.datatable;
                let mvalue=this.datatable



                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;


                mvalue = mvalue.filter( function (post) {
                    return    parseFloat(post.fichetechnique)===1
                })


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.libelle.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }
                this.allItems = mvalue.length;


                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalform,modalformv2,modalformsuppression,
        },

        data() {
            return {
                afficheview:true,
                loadingtable:true,
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                datatiers:[],
                otherdata:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                ismodalviewcodebarre:false,



                activecolums1:true,
                activecolums2:false,
                activecolums3:false,
                activecolums4:false,
                activecolums5:false,
                activecolums6:false,
                activecolums7:false,


                selectedmagasin:null,
                searchword:"",
                searchtrierletableau:"",


                allItems:0,
                lastkey:0,
                paginationpage:1,
                nextPage:1,
                countItems:1,
                countPageItems:0,


                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 10,
                Defaultpage: 1,
                DefaultperPage: 10,
                pages: [],
            };
        },
        methods: {

            formatMoney(value){
                return currencyFormatDE(value)

            },


            btnmodifier(value){

                let mname="Définir la fiche technique "+value.libelle


                let  Item=   {
                    pid:'',
                    pidar:value.pid,
                    pidmag:this.selectedmagasin.pid,
                    pidm:'',
                    article:value.libelle,
                    unite:value.unite,

                    detailefiche:[],

                };


                this.$refs.modalform.show(mname,"update",Item);

            },

            btnsaisiev2(value){

                let  Item=   {
                    pidar:value.pid,
                    pidmag:this.selectedmagasin.pid,
                    article:value.libelle,
                    unite:value.unite,
                };

                this.$refs.modalformv2.show("Fiche technique "+value.libelle,Item);

            },

            filterDataByKey(data, searchKey) {
        console.log("🔍 Valeur recherchée :", searchKey);

        const filteredData = data.filter(item => {
            console.log("📌 Vérification de l'objet :", item);

            // Vérifier si `jsonarticles` existe et est un tableau
            if (!Array.isArray(item.jsonarticles)) {
                console.warn("⚠️ Propriété jsonarticles manquante ou invalide :", item);
                return false;
            }

            // Vérifier si un élément dans `jsonarticles` a `mg.pid` correspondant à `searchKey`
            const hasMatchingKey = item.jsonarticles.some(subItem => {
                if (!subItem.mg || !subItem.mg.pid) {
                    console.warn("⚠️ mg.pid manquant dans :", subItem);
                    return false;
                }

                const pidValue = subItem.mg.pid.toString().toLowerCase();
                console.log(`🔍 Comparaison ${pidValue} === ${searchKey.toLowerCase()}`);
                return pidValue === searchKey.toLowerCase();
            });

            console.log(`✅ Résultat pour cet objet : ${hasMatchingKey ? "Match trouvé" : "Aucun match"}`);
            return hasMatchingKey;
        });

        console.log("🎯 Résultat final :", filteredData);
        return filteredData;
    },



    async load(){
                if (this.selectedmagasin===null) return ;


                let mvalue=cloneobjet(this.listedesarticles),searchKey=this.selectedmagasin.pid.toString().toLowerCase()

                console.log("searchKey ********* ",searchKey)

              //  this.datatable= mvalue.filter(item => item.jsonarticles.some(subItem => subItem.mg.pid.toString().toLowerCase() === searchKey));
                this.datatable= this.filterDataByKey(mvalue,searchKey);


                     },

            async loadtrt(){
                this.$store.dispatch('resetloadlistedesarticles')
                this.$store.dispatch('resetloadlisteotherdatacentredeconsommation_paramcom_magasin')
                this.selectedmagasin=null
                this.datatable=[]
            },


            async loadinputlibelleforms(){



                let $VALUEDATAPRICE=JwtService.getVALUEDATAPRICE()

                if (isset($VALUEDATAPRICE)){

                    this.datainputlibelleforms=JSON.parse($VALUEDATAPRICE);


                }
                else{

                    const t = this;
                    let url=process.env.VUE_APP_API_URL+'/12478855libelinputindex2iofdofiloadexp2/'+this.$store.state.appsociete+'/'+randomString();
                    let response =   axios  .get(url,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                    let res= await response
                        .then(function (res){
                            t.$store.dispatch('lancerchargement',false)


                            if(res.data.success){


                                t.datainputlibelleforms=[];

                                t.datainputlibelleforms=res.data.valuedataprice;

                                JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))


                            }
                            else{
                                t.datainputlibelleforms=[];

                            }


                        })
                        .catch((error)=>{

                                t.$store.dispatch('lancerchargement',false)
                            }
                        )
                        .finally(() =>{

                            t.$store.dispatch('lancerchargement',false)


                        })
                }



            },

            async loadreturnotherdata(){

                /* let $VALUEDATAPRICE=JwtService.getVALUEDATAPRICE()

                 if (isset($VALUEDATAPRICE)){

                     this.datainputlibelleforms=JSON.parse($VALUEDATAPRICE);


                 }
                 else{*/


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/ar85474524otherdatadofodfidfoioienf55485/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.otherdata=[];

                            t.otherdata=res.data.otherdata;

                            // JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))

                        }
                        else{
                            t.otherdata=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                //  }



            },

            btnsuppression(value){

                if (value.nbreusearticle===1 || value.nbreusearticle==='1'){

                    toastr['error']( "Impossible de supprimer cet article. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT SUPPRIMER "+value.libelle+" ?";

                this.$refs.modalformsuppression.show(titlemodal,value);

            },

            close(){

                this.isdisplay=false;

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal;

               // this.loadreturnotherdata();
                //this.loadinputlibelleforms();
                //this.load();
                this.isdisplay=true;
            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1100px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-body--flush { padding:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; gap:0.6rem; }
.cf-foot-actions { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; justify-content:flex-end; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.6rem; align-items:center; flex-wrap:wrap; }
.search-wrap { position:relative; flex:1; min-width:200px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.cf-select-wrap { position:relative; }
.cf-mag-select { min-width:200px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select { appearance:none; padding-right:28px; cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }
.cf-toolbar-meta { display:flex; align-items:center; justify-content:space-between; margin-top:0.7rem; gap:0.75rem; flex-wrap:wrap; }
.cf-check { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); cursor:pointer; }
.cf-check input { accent-color:rgb(var(--primary)); width:16px; height:16px; }
.cf-perpage { display:flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); }
.cf-select--sm { appearance:none; height:34px; padding:0 28px 0 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); cursor:pointer; }
.cf-count b { color:var(--cf-ink-strong); }

/* Table */
.table-scroll-wrap { overflow:auto; }
.doc-scroll { max-height:58vh; }
.doc-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:520px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.6rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.td--center { text-align:center; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }

/* Skeleton */
.cf-skeleton { padding:1rem; }
.cf-skeleton-bar { height:0.9rem; border-radius:4px; background:var(--cf-surface-alt); margin-bottom:0.9rem; }
.cf-skeleton-bar:nth-child(even) { background:#e2e8f0; }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

/* Footer / pagination */
.cf-foot-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }
.pagination { display:flex; align-items:center; gap:4px; }
.cf-ellipsis { padding:0 4px; color:var(--cf-faint); }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.doc-scroll::-webkit-scrollbar { width:6px; height:6px; }
.doc-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .doc-scroll { max-height:64vh; } }
</style>
